import React, { useState, useEffect, useContext } from "react";
import {
  Step,
  Grid,
  Box,
  Card,
  Dialog,
  Button,
  Stepper,
  Tooltip,
  MenuItem,
  TextField,
  IconButton,
  Typography,
  StepButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { toJS } from "mobx";
import moment from "moment";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import "moment/locale/es-mx";
import { esES as localeDate } from "@mui/x-date-pickers/locales";
import {
  esES,
  DataGrid,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid";

import DeleteDialog from "../../app/common/DeleteDialog";
import DialogComponent from "../../app/common/DialogComponent";

import FormDatosEnvio from "../../shared/components/FormDatosEnvio";
import { blobToBase64 } from "../../app/util/util";
import { ErrorMessages } from "../../app/util/messages";
import { RootStoreContext } from "../../app/store/root";
import { EnumStatusCatalogs } from "../../shared/Enumerables";

// STEPER
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "primary",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "primary",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#784af4",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

function generateRandom() {
  var length = 8,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

function generateCount() {
  var length = 1,
      // charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      // retVal = "",
      retVal = null;
      // genCountX = 0;
  for (var i = 0, n = length; i < length; ++i) {
      // retVal += charset.charAt(Math.floor(Math.random() * n));
      genCountX = genCountX +1;
      retVal = genCountX;
  }
  return retVal;
}

var genCountX = 0;

var DateFinal;



QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const initialStateDetail = {
  rowid: undefined,
  idPartidaGuia: undefined,
  numeroRemisionFactura: undefined,
  numeroOrdenCompra: undefined,
  posicionOrdenCompra: undefined,
  cantidadBultos: 1,
  cantidadMercancia: 1,
};
const steps = ["Nueva guía", "Creación de guía"];
const ModalCreacionGuia = ({ open, onClose }) => {
  const rootStore = useContext(RootStoreContext);
  const { alertError } = rootStore.alertStore;
  const { setRowDelete } = rootStore.deleteStore;
  const { createdGuium, getGuideFile } = rootStore.shipmentStore;
  const { entities, getAllByFilter } = rootStore.destinoStore;

  /* UseStates */
  const [details, setDetails] = useState([]);
  const [model, setModel] = useState(undefined);
  const [modelDb, setModelDb] = useState(undefined);
  const [errors, setErrors] = useState({
    idDestino: false,
    descripcionEnvio: false,
    fechaEstimadaLlegada: false,
  });
  const [messages, setMessages] = useState({
    idDestino: undefined,
    descripcionEnvio: undefined,
    fechaEstimadaLlegada: undefined,
  });
  const [urlBlob, setUrlBlob] = useState(undefined);
  const [detail, setDetail] = useState(initialStateDetail);
  const [indexDetail, setIndexDetail] = useState(undefined);
  const [isUpdateDetail, setIsUpdateDetail] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [pageSize, setPageSize] = useState(5);
  const [activeStep, setActiveStep] = useState(0);
  const [pageSizeReading, setPageSizeReading] = useState(5);

  const [isSend, setIsSend] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const [showDialog, setShowDialog] = useState(false);
  const [fieldName, setFieldName] = useState(null);
  const [actionDialog, setActionDialog] = useState(null);
  const [dialogMessage, setDialogMessage] = useState(null);
  const [noRemisionFactura, setNoRemisionFactura] = useState(undefined);
  const [rowid, setRowId] = useState(undefined);
  /* End UseStates */

  useEffect(() => {
    getAllByFilter({
      idEstatus: EnumStatusCatalogs.Activo,
      isSearchByUserIdProvider: true,
    });
  }, []);

  /* Methods */
  const setValue = (key, value) => {
    const newModel = { ...model, ...{ [key]: value } };
    setModel(newModel);
    onValidateContinueButton(newModel);
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  const updatePartida = (params) => {
    const row = toJS(params.row);
    if (row && Object.keys(row).length > 0) {
      const index = details.findIndex(
        (x) => x.rowid === row.rowid
        // (x) => x.numeroRemisionFactura === row.numeroRemisionFactura
      );
      setDetail({ ...row });
      setIndexDetail(index);
      setIsUpdateDetail(true);
    }
  };
  const deletePartida = (params) => {
    const row = toJS(params.row);
    if (row && Object.keys(row).length > 0) {
      setRowDelete({
        NameRow: row.numeroRemisionFactura,
        MessageWhenDelete: "",
      });
      setFieldName("esta partida");
      setNoRemisionFactura(row.numeroRemisionFactura);
      setRowId(row.rowid);
      setShowDeleteDialog(true);
    }
  };
  const closeDeleteDialog = () => {
    setFieldName(null);
    setRowDelete(undefined);
    setShowDeleteDialog(false);
    setNoRemisionFactura(null);
    setRowId(null);
  };
  const onValidateContinueButton = (
    modelForValidation = undefined,
    isSend = false
  ) => {
    modelForValidation = modelForValidation ? modelForValidation : model;
   
    if (isSend) setDisabled(true);
    else if (
      modelForValidation?.idDestino !== undefined &&
      modelForValidation?.fechaEstimadaLlegada !== undefined &&
      modelForValidation?.fechaEstimadaLlegada !== null &&
      modelForValidation?.descripcionEnvio !== undefined &&
      modelForValidation?.descripcionEnvio?.length > 0 &&
      (modelForValidation?.fechaEstimadaLlegada?._i?.length >= 8 || modelForValidation?.fechaEstimadaLlegada._isValid == true)
      
    )
      setDisabled(false);
    else setDisabled(true);
  };
  const validateModel = () => {
    const errors = [],
      objMessages = {};

    if (!model?.idDestino) {
      errors.push("idDestino");
      Object.assign(objMessages, {
        idDestino: ErrorMessages.envio.destinationRequired,
      });
    }
    if (!model?.fechaEstimadaLlegada) {
      errors.push("fechaEstimadaLlegada");
      Object.assign(objMessages, {
        fechaEstimadaLlegada: ErrorMessages.envio.estimatedArrivalDateRequired,
      });
    }
    if (!model?.descripcionEnvio) {
      errors.push("descripcionEnvio");
      Object.assign(objMessages, {
        descripcionEnvio: ErrorMessages.envio.destinationRequired,
      });
    }
    if (details.length <= 0) {
      errors.push("Detalles");
      alertError("Ingrese al menos una partida para continuar");
    }

    if (errors.length > 0) {
      const objErrors = {};
      for (const error of errors) {
        Object.assign(objErrors, { [error]: true });
      }
      setErrors({
        ...errors,
        ...objErrors,
      });
      setMessages({
        ...messages,
        ...objMessages,
      });
    }

    onValidateContinueButton();
    return errors.length <= 0;
  };
  const handleContinue = () => {
    if (validateModel()) {
      setIsSend(true);
      onValidateContinueButton(undefined, true);
      const saveModel = { ...model };
      saveModel.detalles = [...details];
      createdGuium(saveModel).then(
        async (response) => {
          await getUrlFile(response?.idGuia);
          setIsSend(false);
          setModelDb({ ...response });
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          onValidateContinueButton(undefined, false);
        },
        (err) => {
          setIsSend(false);
          onValidateContinueButton(undefined, false);
        }
      );
    }
  };
  const handleUpdatePartida = () => {
    const newDetails = [...details];
    if (detail) {
      if (indexDetail !== undefined && indexDetail !== -1) {
        newDetails.splice(indexDetail, 1, detail);
      }
    }
    setIsUpdateDetail(false);
    setIndexDetail(undefined);
    setDetails([...newDetails]);
    setDetail({ ...initialStateDetail });
  };
  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  const onCloseDialog = () => {
    onValidateContinueButton(undefined, false);
    console.log(model);
    // setModel(undefined);
    // setDetails([]);
    setInitialState();
    onClose();
  };
  const setInitialState = () => {
    setDetails([]);
    setModel(undefined);
    setModelDb(undefined);
    setErrors({
      idDestino: false,
      descripcionEnvio: false,
      fechaEstimadaLlegada: false,
    });
    setMessages({
      idDestino: undefined,
      descripcionEnvio: undefined,
      fechaEstimadaLlegada: undefined,
    });


    setDetail(initialStateDetail);
    setIndexDetail(undefined);
    setIsUpdateDetail(false);
    setShowDeleteDialog(false);

    setPageSize(5);
    setActiveStep(0);
    setPageSizeReading(5);

    setIsSend(false);
    setDisabled(true);

    setShowDialog(false);
    setFieldName(null);
    setActionDialog(null);
    setDialogMessage(null);
    setNoRemisionFactura(undefined);
  };
  const getUrlFile = async (id) => {
    let pdf = await getGuideFile(id);
    const pdfBase64 = await blobToBase64(pdf.data);
    setUrlBlob(pdfBase64);
  };
  /* End Methods */

  const columns = [
    {
      field: "numeroRemisionFactura",
      headerName: "No. de remisión de factura",
      minWidth: 100,
      flex: 1,
      // sort: 'asc',
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">No. de remisión de factura</span>
      ),
    },
    {
      field: "numeroOrdenCompra",
      headerName: "No. de orden de compra",
      minWidth: 100,
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">No. de orden de compra</span>
      ),
    },
    {
      field: "posicionOrdenCompra",
      headerName: "Posición de orden de compra",
      minWidth: 100,
      flex: 1,
      // sort: 'asc',
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Posición de orden de compra</span>

      ),
    },
    {
      field: "cantidadBultos",
      headerName: "Cantidad de bultos",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Cantidad de bultos</span>
      ),
    },
    {
      field: "cantidadMercancia",
      headerName: "Cantidad de mercancía",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Cantidad de mercancía</span>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      headerClassName: "tableHeaders",
      getActions: (params) => [
        <Tooltip title="Editar" placement="top">
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Editar"
            color="primary.main"
            onClick={() => { setDetail({ ...initialStateDetail }); updatePartida(params)}}
            renderCell={() => { setDetail({ ...initialStateDetail }); updatePartida(params)}}
          />
        </Tooltip>,
        <Tooltip title="Eliminar" placement="top">
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Eliminar"
            color="primary.main"
            onClick={() => { setDetail({ ...initialStateDetail }); deletePartida(params)}}
            renderCell={() => { setDetail({ ...initialStateDetail }); deletePartida(params)}}
          />
        </Tooltip>,
      ],
    },
  ];
  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale="es-mx"
      localeText={
        localeDate.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <Dialog open={open} onClose={onClose} maxWidth={"lg"} fullWidth={true}>
        <DialogTitle>
          Nueva guía
          <IconButton
            aria-label="close"
            onClick={() => {
              if (activeStep === steps.length - 1) {
                onCloseDialog();
              } else {
                setShowDialog(true);
                setActionDialog("close");
                setDialogMessage(
                  "Si cierra o cancela el registro de esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
                );
              }
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Stepper
            nonLinear
            alternativeLabel
            activeStep={activeStep}
            connector={<QontoConnector />}
          >
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step key={label} {...stepProps}>
                  {/* <StepLabel {...labelProps} StepIconComponent={QontoStepIcon}>{label}</StepLabel> */}
                  <StepButton
                    {...labelProps}
                    StepIconComponent={QontoStepIcon}
                    onClick={handleStep(index)}
                  >
                    {label}
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>

          {activeStep === 0 ? (
            <React.Fragment>
              <Typography variant="h6">Datos del envío</Typography>
              <FormDatosEnvio
                Entity={detail}
                IsEdit={isUpdateDetail}
                OnFinish={(data) => {
                  const newDetails = [...details];
                  if (data)
                    if (isUpdateDetail) {
                      setShowDialog(true);
                      setActionDialog("update");
                      setDialogMessage(
                        "¿Está seguro que desea actualizar esta partida? "
                      );
                      setDetail({ ...data });
                    } else {
                      newDetails.push(data);
                      setDetail({ ...initialStateDetail });
                    }
                  setDetails([...newDetails]);
                }}
              />

              <Box
                sx={{
                  width: "100%",
                  "& .tableHeaders": {
                    color: "primary.main",
                  },
                }}
              >
                <DataGrid
                  localeText={
                    esES.components.MuiDataGrid.defaultProps.localeText
                  }

                  disableColumnMenu = {true}
                  autoHeight
                  // sortModel={[{ field: "numeroRemisionFactura", sort: "desc" }]}
                  rows={details}
                  columns={columns}
                  initialState= {{

                  }      
                  }
                  dataSource={details}
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  // getRowId={(row) => (row.id + row.numeroRemisionFactura + row.numeroOrdenCompra + row.posicionOrdenCompra)}
                  // getRowId={(row) => row.rowid = generateRandom()}
                  getRowId={(row) => row.rowid = generateCount()}
                  rowsPerPageOptions={[5, 10, 20]}
                  // sort={['numeroRemisionFactura','asc']}
                  // setSorting={['numeroRemisionFactura','asc']}
                  pagination
                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  components={{ Toolbar: GridToolbar }} 
                  componentsProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 },
                      csvOptions: { disableToolbarButton: true },
                      printOptions: { disableToolbarButton: true },
                    },
                  }}
                />
              </Box>

              <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item sm={6}>
                  <TextField
                    size="small"
                    margin="normal"
                    select
                    required
                    fullWidth
                    id="selectDestino"
                    label="Destino de entrega"
                    error={errors.idDestino}
                    onChange={(e) => {
                      setValue("idDestino", e.target.value);
                      setError("idDestino", e.target.value.length <= 0);
                      setMessage(
                        "idDestino",
                        e.target.value.length <= 0
                          ? ErrorMessages.envio.destinationRequired
                          : ""
                      );
                    }}
                    helperText={messages.idDestino}
                    value={model?.idDestino || ""}
                  >
                    {entities.map((x) => (
                      <MenuItem key={x.idDestino} value={x.idDestino}>
                        {x.nombreEmpresaDestino}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item sm={6}>
                  <DatePicker
                    label="Fecha prevista de entrega de guías"
                    disablePast={true}
                    value={model?.fechaEstimadaLlegada || ""}
                    // onBlur={(value) =>{
                    //   if(value.length > 10 || value.length <10){
                    //     setValue("fechaEstimadaLlegada", value);
                    //     // setError("fechaEstimadaLlegada");
                    //     setError("fechaEstimadaLlegada",value);
                    //     setMessage("fechaEstimadaLlegada",value.length > 10 || value.length <10
                    //     ? ErrorMessages.envio.incorrectDate
                    //     : ""
                    // );
                    //   }
                    // }}
                    onAccept={(value) => {
                      setDisabled(false)
                    }}
                    onChange={(value) => {
                      setValue("fechaEstimadaLlegada", value);
                      DateFinal = value; 
               
                      setValue("fechaEstimadaLlegada", value);
                      setError("fechaEstimadaLlegada", !value);
                      setMessage(
                        "fechaEstimadaLlegada",
                        !value
                          ? ErrorMessages.envio.estimatedArrivalDateRequired
                          : ""
                      );
                    }}
                    renderInput={({ inputRef, inputProps, InputProps }) => (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          size="small"
                          margin="normal"
                          required
                          fullWidth
                          label="Fecha prevista de entrega de guías"
                          error={errors.fechaEstimadaLlegada}
                          helperText={messages.fechaEstimadaLlegada}
                          ref={inputRef}
                          {...inputProps}
                      onKeyUp={(value) =>{
                        if(DateFinal != undefined  && (DateFinal._i.length > 10 || DateFinal._i.length <10)){
                          // setValue("fechaEstimadaLlegada", value);
                          // setError("fechaEstimadaLlegada");
                          
                            setDisabled(true)
                        
                          
                          setError("fechaEstimadaLlegada",DateFinal);
                          setMessage("fechaEstimadaLlegada",DateFinal._i.length > 10 || DateFinal._i.length <10
                          ? ErrorMessages.envio.incorrectDate
                          : ""
                          
                      );
                        }else{
                          if(DateFinal?._i?.length >= 8)
                          setDisabled(false)
                        }
                      }}
                      onBlur={(value) =>{
                      if(DateFinal?._i?.length != null && (DateFinal._i.length > 10 || DateFinal._i.length <10)){
     
                        setError("fechaEstimadaLlegada",DateFinal);
                        setMessage("fechaEstimadaLlegada",DateFinal._i.length > 10 || DateFinal._i.length <10
                        ? ErrorMessages.envio.incorrectDate
                        : ""
                        
                    );
                      }else{
                           if(DateFinal?._i?.length >= 8)
                          setDisabled(false)
                      }
                    }}
                        />
                        {InputProps?.endAdornment}
                      </Box>
                    )}
                  />
                </Grid>

                <Grid item sm={6}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="detallesEnvio"
                    label="Detalles del envío"
                    name="detallesEnvio"
                    rows={3}
                    multiline
                    inputProps={{ maxLength: 100 }}
                    error={errors.descripcionEnvio}
                    onChange={(e) => {
                      setValue("descripcionEnvio", e.target.value);
                      setError("descripcionEnvio", e.target.value.length <= 0);
                      setMessage(
                        "descripcionEnvio",
                        e.target.value.length <= 0
                          ? ErrorMessages.envio.shippingDescriptionRequired
                          : ""
                      );
                    }}
                    helperText={messages.descripcionEnvio}
                    value={model?.descripcionEnvio || ""}
                  />
                </Grid>
              </Grid>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Grid
                container
                direction={"column"}
                columnSpacing={{ xs: 2, sm: 2, md: 3 }}
                rowSpacing={2}
                mb={3}
              >
                <Grid item>
                  <Typography variant="h5" color={"success.main"}>
                    ¡Guía creada!
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body1">
                    # {modelDb?.numeroGuia}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction={"column"}
                columnSpacing={{ xs: 2, sm: 2, md: 3 }}
                rowSpacing={2}
              >
                <Grid item>
                  <Typography variant="h5">Información de la guía</Typography>
                </Grid>
                <Grid item>
                  <Card className="card" sx={{ width: "100%", height: 500 }}>
                    {modelDb && (
                      <embed
                        src={urlBlob}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                      />
                    )}
                  </Card>
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </DialogContent>

        <DialogActions variant="paddi">
          {activeStep === 0}
          {
            <Button
              color="secondary"
              variant="contained"
              sx={{ color: "#fff" }}
              disabled={isSend ? isSend : activeStep === 1}
              onClick={() => {
                setShowDialog(true);
                setActionDialog("close");
                setDialogMessage(
                  "Si cierra o cancela el registro de esta ventana se perderá la información capturada. ¿Está seguro que desea continuar?"
                );
              }}
            >
              Cancelar
            </Button>
          }
          <Button
            disabled={disabled}
            variant="contained"
            onClick={() => {
              if (activeStep === steps.length - 1) {
                onCloseDialog();
              } else {
                setShowDialog(true);
                setActionDialog("continue");
                setDialogMessage(
                  "¿Está seguro que todos los datos son correctos?"
                );
              }
            }}
          >
            {activeStep === steps.length - 1 ? "Cerrar" : "Continuar"}
          </Button>
        </DialogActions>
      </Dialog>
      <DeleteDialog
        Open={showDeleteDialog}
        FieldName={fieldName}
        OnClose={() => {
          closeDeleteDialog();
        }}
        OnFinish={() => {
          const newDetails = [...details];
          const index = newDetails.findIndex(
            (x) => x.rowid === rowid
            // (x) => x.numeroRemisionFactura === noRemisionFactura
          );
          if (index !== -1) {
            newDetails.splice(index, 1);
          }
          setInitialState();
          setModel(undefined);
          closeDeleteDialog();
        }}
      />
      <DialogComponent
        Open={showDialog}
        Message={dialogMessage}
        OnClose={() => setShowDialog(false)}
        OnAccept={() => {
          if (actionDialog === "close") {
            onClose();
            setInitialState();
            setDetail({ ...initialStateDetail });
            setIsUpdateDetail(false);

           }
        if (actionDialog === "continue") {
          handleContinue();
          setDetail({ ...initialStateDetail });
          setIsUpdateDetail(false);

          
        }
        if (actionDialog === "update") {
          handleUpdatePartida();
          setDetail({ ...initialStateDetail });  
          setIsUpdateDetail(false); 

        }
          setShowDialog(false);
        }}
      />
    </LocalizationProvider>
  );
};

export default observer(ModalCreacionGuia);
